<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-08-17 11:14:34
--> 
<template>
  <div>
    <OrganizationalManagement></OrganizationalManagement>
  </div>
</template> 
 
<script>
import OrganizationalManagement from './organizationalManagement'
export default {
  components: {
    OrganizationalManagement
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>